import { render, staticRenderFns } from "./ResumenFoliosVisor.vue?vue&type=template&id=922ec146&scoped=true"
import script from "./ResumenFoliosVisor.vue?vue&type=script&lang=js"
export * from "./ResumenFoliosVisor.vue?vue&type=script&lang=js"
import style0 from "./ResumenFoliosVisor.vue?vue&type=style&index=0&id=922ec146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922ec146",
  null
  
)

export default component.exports